export function getScorePercentage(result) {
  if (!result.total) return 0;
  return Math.round((result.score / result.total) * 100);
}

export function computeDashboardStats(results) {
  if (!results.length) {
    return {
      totalParticipants: 0,
      totalAttempts: 0,
      averageScore: 0,
      highestScore: 0,
      lowestScore: 0,
      scoreDistribution: [
        { range: "0-40%", count: 0 },
        { range: "40-60%", count: 0 },
        { range: "60-80%", count: 0 },
        { range: "80-100%", count: 0 },
      ],
      attemptsByDay: [],
    };
  }

  const uniquePhones = new Set(results.map((r) => r.candidate?.phoneNumber).filter(Boolean));
  const percentages = results.map(getScorePercentage);

  const distribution = { "0-40%": 0, "40-60%": 0, "60-80%": 0, "80-100%": 0 };
  percentages.forEach((p) => {
    if (p < 40) distribution["0-40%"] += 1;
    else if (p < 60) distribution["40-60%"] += 1;
    else if (p < 80) distribution["60-80%"] += 1;
    else distribution["80-100%"] += 1;
  });

  const dayMap = {};
  const now = new Date();
  for (let i = 29; i >= 0; i -= 1) {
    const d = new Date(now);
    d.setDate(d.getDate() - i);
    const key = d.toISOString().split("T")[0];
    dayMap[key] = 0;
  }

  results.forEach((r) => {
    const key = new Date(r.timestamp).toISOString().split("T")[0];
    if (dayMap[key] !== undefined) {
      dayMap[key] += 1;
    }
  });

  return {
    totalParticipants: uniquePhones.size,
    totalAttempts: results.length,
    averageScore: Math.round(percentages.reduce((a, b) => a + b, 0) / percentages.length),
    highestScore: Math.max(...percentages),
    lowestScore: Math.min(...percentages),
    scoreDistribution: Object.entries(distribution).map(([range, count]) => ({ range, count })),
    attemptsByDay: Object.entries(dayMap).map(([date, count]) => ({
      date: date.slice(5),
      count,
    })),
  };
}

export function resolveQuestionsForResult(result, questions) {
  if (result.questionIds?.length) {
    return result.questionIds.map((id) => questions.find((q) => String(q._id) === String(id)) || null);
  }
  return result.answers.map((_, i) => questions[i] || null);
}
